import { z } from 'zod'

import { BidDomainSelectModelSchema } from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { BidQueryShapeSchema } from '../types.ts'

// Select a single bid by bidId or by projectId/agencyId
export const SelectBidInputSchema = BidDomainSelectModelSchema.pick({
  bidId: true,
})

export type SelectBidInput = ZodInfer<typeof SelectBidInputSchema>

export const BidAclSchema = z.object({
  canAcceptBid: z.boolean(),
  canDiscardBid: z.boolean(),
  canRejectBid: z.boolean(),
  canSubmitBid: z.boolean(),
  canUpdateBid: z.boolean(),
})

export const SelectBidOutputSchema = BidQueryShapeSchema.extend({
  acl: BidAclSchema,
})

export type SelectBidOutput = ZodInfer<typeof SelectBidOutputSchema>
